<!--
		描述： 六算分析图
		时间： xx
		created by ws
-->
<template>
	<div class="charts-main structure-layout">
		<!-- 左侧树表 -->
		<div class="structure-left charts-left" :class="{'leftWidth': !showLeft}">
			<div class="baseForm-layout h100">
				<div class="baseForm-header overflow-hidden">
					<span class="text" v-show="showLeft">项目结构</span>
					<div class="btnGroups">
						<el-button type="text" icon="el-icon-d-arrow-left" title="收起" v-if="showLeft" @click="handleShow"></el-button>
						<el-button type="text" icon="el-icon-d-arrow-right" title="展开" v-else @click="handleShow"></el-button>
						<el-select v-model="expandValue" class="ml10 select-width" placeholder="请选择" size="small" @change="onChangeLevel">
							<el-option :value="0" label="展开到一级"></el-option>
							<el-option :value="1" label="展开到二级"></el-option>
							<el-option :value="2" label="展开到三级"></el-option>
							<!-- <el-option :value="3"
                               label="展开到四级"></el-option> -->
						</el-select>
					</div>
				</div>
				<div class="baseForm-content h100">
					<!-- 树形表格 -->
					<div class="h100 structure-table" ref="tableContent">
						<el-table :data="tableData" ref="structureTree" row-key="id" border :height="tableH" highlight-current-row :expand-row-keys="expandKeys" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" :row-class-name="rowClassName" @row-click="rowClick">
							<el-table-column prop="sname" label="项目名称" min-width="110">
								<template slot-scope="scope" class="myCell">
									<el-tooltip class="item" effect="dark" :content="scope.row.sname" placement="right">
										<span class="text-overflow" :class="scope.row.levelType === 0 ? 'cell-text' : 'cell-tooltip'">{{ scope.row.levelType === 0 ? scope.row.sname : '' }}</span>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column prop="singleName" label="单项工程名称" show-overflow-tooltip width="120">
								<template slot-scope="scope">
									{{ scope.row.levelType === 1 ? scope.row.sname : '' }}
									<el-tooltip placement="right"
												effect="light"
												v-if="scope.row.tags !== '' && scope.row.levelType !== 2">
										<div slot="content"
												class="tag-label-tooltip">
											<el-tag class="mr10 mb10"
													size="mini"
													v-for="(item, index) in toArray(scope.row.tags)"
													:key="index">{{ item }}</el-tag>
										</div>
										<svg-icon icon-class="biaoqian"
													class="ml5"></svg-icon>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column prop="unitName" width="120" label="单位工程名称" show-overflow-tooltip>
								<template slot-scope="scope">{{ scope.row.levelType === 2 ? scope.row.sname : '' }}</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<!-- 右侧表单 -->
		<div class="charts-right">
			<div class="baseForm-layout h100">
				<div class="baseForm-header">
					<!-- <span class="title pdl10 text-overflow">
						<el-tooltip class="item" effect="dark" :content="curShowName" placement="bottom-start">
							<span>{{ curShowName }}</span>
						</el-tooltip>
					</span> -->
					<div class="btnGroups">
						<!-- <el-select size="mini" v-model="curUnit" style="width: 100px">
							<el-option value="元" label="元"></el-option>
							<el-option value="万元" label="万元"></el-option>
						</el-select> -->
						<el-button-group class="flex ml10">
							<el-button type="" :class="{activeBtn: showType === 'bar'}" size="small" @click="changeShow('bar')">柱状图 / 折线图</el-button>
							<el-button type="" :class="{activeBtn: showType === 'pie'}" size="small" @click="changeShow('pie')">饼图</el-button>
						</el-button-group>
						<el-button type="primary" size="small" class="ml10" v-show="showType === 'bar'" @click="doExportPic" icon="el-icon-upload">导出</el-button>
					</div>
				</div>
				<div class="baseForm-content h100">
					<!-- 柱状图 -->
					<div class="bar-container" v-if="showType === 'bar'">
						<div class="box" id="bar_chart"></div>
					</div>
					<!-- 饼图 -->
					<div class="pie-container" v-show="showType === 'pie'">
						<div class="title" v-if="curLevel === 0">
							<el-button type="text" class="btn-text mr10" @click="showTotalOrEstimate('total')">总概算</el-button> / <el-button type="text" class="btn-text" @click="showTotalOrEstimate('estimate')">建安概算</el-button>
						</div>
						<div class="title" v-else>
							<el-button type="text" class="btn-text">建安概算</el-button>
						</div>
						<div class="box" id="estimate_chart"></div>
						<div class="box" id="control_chart"></div>
						<div class="box no-bdRight" id="bidding_chart"></div>
						<div class="box no-bdBottom" id="report_chart"></div>
						<div class="box no-bdBottom" id="before_chart"></div>
						<div class="box no-bdRight no-bdBottom" id="after_chart"></div>
					</div>
				</div>
			</div>
			<!-- 大图弹窗 -->
			<div class="enlarge-container" v-if="showBigger">
				<h3 class="enlarge-title">大图查看<em class="el-icon-close" @click="showBigger = false"></em></h3>
				<div id="enlarge_chart"></div>
			</div>
			<div class="enlarge-wrap" v-if="showBigger"></div>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import {
	getProjectCostAnalysis,
	getTotalEstimate,
	getSheetAnalysis
} from '@/api/modules/analysisCharts.js'
import { getStructureData } from '@/api/modules/dataProject'

import { dateFormatCN } from '@/utils/tools.js'

export default {
	name: 'structure-home',
	data() {
		return {
			tableData: [],
			expandKeys: [],
			expandValue: 2,
			tableH: 100,
			btnLoading: false,
			showLeft: true, // 是否展示左侧
			showBigger: false, // 是否展示大图
			showType: '',
			curRowId: '', // 当前点击的左侧行ID
			curName: '', // 当前点击的左侧行 名称
			curLevel: 0, // 当前层级
			curShowName: '', // 当前点击的左侧行 全部名称
			originalData: [], // 原始返回的数据
			staticData: [], // 六算分析数据
			isVisible: false, // 导出信息是否展示
			// 六算预留金额
			reservedObj: {
				controlReserveMoney: 0, // 控制价
				biddingReserveMoney: 0, // 中标价
				reportReserveMoney: 0, // 送审价
				beforeReserveMoney: 0, // 初审价
				afterReserveMoney: 0, // 审批价
			},
			curUnit: '元',
			allColorList: []
		}
	},
	methods: {
		// 获取结构树
		getData() {
			this.tableData = []
			getStructureData({ id: this.curProjectId }).then(res => {
				if (res.code === 0) {
					// 改造数据
					res.data.pid = '0'

					this.tableData.push(res.data)
					this.staticData = this.tableData

					// 设置高亮
					if (this.$refs.structureTree) {
						this.$refs.structureTree.setCurrentRow(res.data)
						setTimeout(() => {
							this.rowClick(res.data)
							this.onChangeLevel(2)
						}, 300)
					}
				}
			}).catch(err => {

			})
		},

		// 递归赋值 pid
		recursiveFn(arr) {
			return new Promise((resolve, reject) => {
				if (arr.children && arr.children.length > 0) {
					arr.children.map(x => {
						x.pid = arr.id

						this.recursiveFn(x)
					})
				}

				resolve(arr)
			})

		},

		// 点击切换展开层级
		onChangeLevel(val) {
			// 先清空
			this.tableData = [];
			this.expandKeys = [];
			// 设置 level
			let _data = JSON.parse(JSON.stringify(this.staticData));
			this.expandLevel(_data, val, this.expandKeys);

			// 展示表格
			setTimeout(() => {
				this.tableData = this.staticData;
				this.$refs.structureTree.doLayout()
			}, 500)
		},

		// 默认key 值展开
		expandLevel(arr, level, backArr) {
			if (arr.length > 0) {
				arr.forEach(x => {
					if (x.children && x.levelType < level) {
						backArr.push(x.id)
						this.expandLevel(x.children, level, backArr)
					}
				})
			}
		},

		// 结构树 行点击事件
		rowClick(row, column, event) {
			let _pname = this.tableData[0].sname
			let name = row.sname
			this.curLevel = row.levelType
			this.showBigger = false

			let _chart = this.$echarts.init(
				document.getElementById('estimate_chart')
			)
			_chart.clear()

			// 设置右边结构名字
			if (row.levelType === 0) {
				this.curShowName = name
			} else if (row.levelType === 1) {
				this.curShowName = _pname + ' | ' + name
			} else {
				// 当前结构树ID
				let _dname = this.tableData[0].children.find(
					x => x.id === row.pid
				).sname
				this.curShowName = _pname + ' | ' + _dname + ' | ' + name
			}
			// 右侧图表
			if (row && row.id) {
				this.curRowId = row.id
				// this.curName = row.sname
				setTimeout(() => {
					this.getCharts(this.showType, row.id)
				}, 300)
			}
		},
		// 行样式
		rowClassName({ row, rowIndex }) {
			if (row.levelType === 0) {
				return 'project-row'
			} else if (row.levelType === 1) {
				return 'single-row'
			} else if (row.levelType === 2) {
				return 'unit-row'
			}
			return ''
		},
		// 点击展示不同的图形模式
		changeShow(type) {
			this.showType = type

			if (this.curRowId) {
				setTimeout(() => {
					this.getCharts(type, this.curRowId)
				}, 300)
			}
		},
		// 获取六算图表数据
		getChartsData() {
			getSheetAnalysis({ id: this.curProjectId })
				.then(res => {
					if (
						res.data.busProContract.children &&
						res.data.busProContract.children.length > 0
					) {
						this.recursiveFn(res.data.busProContract).then(backData => {
							// 赋值
							this.originalData.push(backData)

							// 初始加载
							this.getCharts(this.showType, this.originalData[0].id)
							setTimeout(() => {
								this.getCharts(
									this.showType,
									this.originalData[0].id
								)
							}, 300)
						})
					}
				})
				.catch(err => {
					this.loading = false
				})
		},

		// 获取总概算数据
		getTotalData() {
			this.totalEstimateData = []
			getTotalEstimate({ projectId: this.curProjectId })
				.then(res => {
					this.totalEstimateData = res.data.param
				})
				.catch(err => {})
		},

		// 加载总概算数据图表
		initTotalChart(echart, type) {
			let activeOption = {}
			let that = this

			if (this.curUnit !== '元') {
				this.totalEstimateData.map(x => {
					x.value = (parseFloat(x.value) / 10000).toFixed(2)
				})
			} else {
				this.totalEstimateData.map(x => {
					x.value = x.value
					// x.value = parseFloat(x.value)
				})
			}

			if (type === 'pie') {
				let colorList_old = [
					'#399be1',
					'#36cbcb',
					'#4ecb73',
					'#fbd437',
					'#da6fad',
					'#88b4ca',
					'#d18061',
					'#65c5bd',
					'#4fcce7',
					'#d16361',
					'#b38661'
				]

				let colorList = [
					"#B47C4B",
					"#7A64E7",
					"#5AF243",
					"#D00C87",
					"#D412CA",
					"#D367F7",
					"#65A554",
					"#D39C04",
					"#C64194",
					"#0C5BB6",
					"#7E0BB5",
					"#BD7DC9",
					"#0D3F7D",
					"#E1C6D8",
					"#85BD82",
					"#41B4E6",
					"#9ED366",
					"#435A37",
					"#072897",
					"#8CE78D",
					"#5967B1",
					"#4F61B9",
					"#853855",
					"#69677D",
					"#8768d3",
					"#A5901C",
					"#986D49",
					"#16E03E",
					"#DB3398",
					"#9CB426"
				]

				activeOption = {
					legend: {
						bottom: 20,
						type: 'scroll',
					},
					title: {
						text: '',
						textAlign: 'center',
						top: '5px',
						left: '50%'
					},
					tooltip: {
						formatter: function(params) {
							return `${params.name}: ${params.value} </br>占比： ${params.percent} %`
						}
					},
					toolbox: {
						feature: {
							myTool1: {
								show: true,
								title: '查看大图',
								icon: 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
								onclick: () => {
									// 展示大图
									this.changeEnlarge('totalEstimate')
									// this.$message.warning('等待中...')
								}
							}
						},
						top: 18
					},
					series: [{
						type: 'pie',
						name: '总概算',
						radius: 90,

						label: {
							normal: {
								formatter: `{b|{b}}\n{hr|}\n{value|{c}} ${that.curUnit}`,
								// formatter: `{b}{@${attr}} 元`,
								rich: {
									b: {
										lineHeight: 20
									},
									hr: {
										borderColor: '#5f9ea0',
										width: '100%',
										borderWidth: 0.5,
										height: 0,
										marginTop: 3
									},
									value: {
										lineHeight: 20
									}
								}
							}
						},
						itemStyle: {
							normal: {
								// 饼图块
								color: function(params) {
									let _index = params.dataIndex % that.allColorList.length
									return that.allColorList[_index]
								}
							}
						},
						data: this.totalEstimateData
					}]
				}
			}
			echart.setOption(activeOption)
		},

		// 加载页面数据
		initCharts(echart, type, pid, attr) {
			let resData = []
			let that = this
			let titleObj = {
				estimateMoney: '概算价',
				controlMoney: `控制价`,
				biddingMoney: `中标价`,
				reportMoney: `报审价`,
				beforeMoney: `初审价`,
				afterMoney: `审定价`
			}

			// 获得对应的数据
			resData = this.listData.filter(x => x.pid === pid)
			let params = this.listData.find(x => x.id === pid)
			if (params) {
				if (this.curUnit === '元') {
					this.reservedObj.controlReserveMoney = params.controlReserveMoney || '0.00'
					this.reservedObj.biddingReserveMoney = params.biddingReserveMoney || '0.00'
					this.reservedObj.reportReserveMoney = params.reportReserveMoney || '0.00'
					this.reservedObj.beforeReserveMoney = params.beforeReserveMoney || '0.00'
					this.reservedObj.afterReserveMoney = params.afterReserveMoney || '0.00'
				} else {
					this.reservedObj.controlReserveMoney = (parseFloat(params.controlReserveMoney) / 10000).toFixed(2) || '0.00'
					this.reservedObj.biddingReserveMoney = (parseFloat(params.biddingReserveMoney) / 10000).toFixed(2) || '0.00'
					this.reservedObj.reportReserveMoney = (parseFloat(params.reportReserveMoney) / 10000).toFixed(2) || '0.00'
					this.reservedObj.beforeReserveMoney = (parseFloat(params.beforeReserveMoney) / 10000).toFixed(2) || '0.00'
					this.reservedObj.afterReserveMoney = (parseFloat(params.afterReserveMoney) / 10000).toFixed(2) || '0.00'
				}

			}

			// 定义数组
			let dataSource = []
			let barList = []
			let barColorList_old = [
				'#CDD169',
				'#6F9EA7',
				'#C6866D',
				'#91C5AF',
				'#1193cf',
				'#65c5bd',
				'#ca88c8'
			]

			let barColorList = [
				"#B47C4B",
				"#7A64E7",
				"#5AF243",
				"#D00C87",
				"#D412CA",
				"#D367F7",
				"#65A554",
				"#D39C04",
				"#C64194",
				"#0C5BB6",
				"#7E0BB5",
				"#BD7DC9",
				"#0D3F7D",
				"#E1C6D8",
				"#85BD82",
				"#41B4E6",
				"#9ED366",
				"#435A37",
				"#072897",
				"#8CE78D",
				"#5967B1",
				"#4F61B9",
				"#853855",
				"#69677D",
				"#8768d3",
				"#A5901C",
				"#986D49",
				"#16E03E",
				"#DB3398",
				"#9CB426"
			]
			// let randomColor = []

			// 数据
			resData.forEach((y, index) => {
				let arrSource = []
				arrSource.push(y.sname)
				if (this.curUnit === '元') {
					arrSource.push(y.estimateMoney || 0)
					arrSource.push(y.controlMoney || 0)
					arrSource.push(y.biddingMoney || 0)
					arrSource.push(y.reportMoney || 0)
					arrSource.push(y.beforeMoney || 0)
					arrSource.push(y.afterMoney || 0)
				} else {
					arrSource.push((y.estimateMoney / 10000).toFixed(2) || 0)
					arrSource.push((y.controlMoney / 10000).toFixed(2) || 0)
					arrSource.push((y.biddingMoney / 10000).toFixed(2) || 0)
					arrSource.push((y.reportMoney / 10000).toFixed(2) || 0)
					arrSource.push((y.beforeMoney / 10000).toFixed(2) || 0)
					arrSource.push((y.afterMoney / 10000).toFixed(2) || 0)
				}

				dataSource.push(arrSource)
				// randomColor.push('#' + Math.random().toString(16).substr(2, 6).toUpperCase())

				let _index = index % barColorList.length

				// 柱状图
				if (type === 'bar') {
					let typeObj = {
						type: 'line',
						seriesLayoutBy: 'row',
						stack: '结构',
						areaStyle: {},
						itemStyle: {
							color: that.allColorList[_index]
							// color: '#' + Math.random().toString(16).substr(2, 6).toUpperCase()
						},
						barMaxWidth: 30
						// barWidth: 30
					}
					barList.push(typeObj)
				}
			})

			let activeOption = {}
			// 如果是饼图
			if (type === 'pie') {
				let colorList_old = [
					'#399be1',
					'#36cbcb',
					'#4ecb73',
					'#fbd437',
					'#da6fad',
					'#88b4ca',
					'#d18061',
					'#65c5bd',
					'#4fcce7',
					'#d16361',
					'#b38661'
				]

				let colorList = ['#399be1', '#36cbcb', '#4ecb73', '#fbd437', '#da6fad', '#88b4ca', '#d18061', '#65c5bd', '#4fcce7', '#d16361', '#b38661', '#40E0D0', '#F0E68C', '#F4A460', '#6495ED', '#7B68EE']

				activeOption = {
					legend: {
						bottom: 20,
						type: 'scroll',
					},
					title: {
						text: attr === 'estimateMoney' ? '' : titleObj[attr].slice(0, 3),
						subtext: titleObj[attr].slice(3),
						textAlign: 'center',
						top: '5px',
						left: '50%'
					},
					tooltip: {
						formatter: function(params) {
							let value = params.value[params.encode.value[0]]
							return `${params.name}: ${value} 元 </br>占比： ${params.percent} %`
						}
					},
					toolbox: {
						feature: {
							myTool1: {
								show: true,
								title: '查看大图',
								icon: 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
								onclick: () => {
									// 展示大图
									this.changeEnlarge(attr)
									// this.$message.warning('等待中...')
								}
							}
						},
						top: 18
					},
					dataset: {
						source: [
							[
								'sname',
								'estimateMoney',
								'controlMoney',
								'biddingMoney',
								'reportMoney',
								'beforeMoney',
								'afterMoney',
								'total'
							],
							...dataSource
						]
					},
					series: [{
						type: 'pie',
						radius: 90,
						encode: {
							itemName: 'sname',
							value: attr
						},
						label: {
							normal: {
								formatter: `{b|{b}}\n{hr|}\n{value|{@${attr}} ${this.curUnit}}`,
								// formatter: `{b}{@${attr}} 元`,
								rich: {
									b: {
										lineHeight: 20
									},
									hr: {
										borderColor: '#5f9ea0',
										width: '100%',
										borderWidth: 0.5,
										height: 0,
										marginTop: 3
									},
									value: {
										lineHeight: 20
									}
								}
							}
						},
						itemStyle: {
							normal: {
								// 饼图块
								color: function(params) {
									let _index = params.dataIndex % that.allColorList.length
									return that.allColorList[_index]
									// return '#' + Math.random().toString(16).substr(2, 6).toUpperCase()
								}
							}
						}
					}]
				}
			} else {
				// 如果是柱状图
				activeOption = {
					legend: {
						top: '40px'
					},
					title: {
						text: this.curName + '价格构成',
						textAlign: 'center',
						top: '5px',
						left: '50%'
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								// backgroundColor: '#6a7985'
							}
						}
					},
					toolbox: {
						feature: {
							saveAsImage: {
								title: '保存为png',
								pixelRatio: 2
							},
							magicType: {
								type: ['line', 'bar', 'stack', 'tiled']
							}
						}
					},
					grid: {
						top: '100px',
						left: '15px',
						right: '4%',
						bottom: '10px',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false // 坐标轴两边是否 留白
					}],
					yAxis: {
						type: 'value'
					},
					dataset: {
						source: [
							[
								'sname',
								'概算价',
								'控制价',
								'中标价',
								'报审价',
								'初审价',
								'审定价'
							],
							...dataSource
						]
					},
					series: [...barList]
				}
			}
			echart.setOption(activeOption)
		},
		// 图表 获取
		getCharts(type, pid) {
			// 柱状图
			if (type === 'bar') {
				let _item = document.getElementById('bar_chart')
				if (_item) {
					let _barChart = this.$echarts.init(
						_item
						// document.getElementById('bar_chart')
					)
					_barChart.clear()

					this.initCharts(_barChart, 'bar', pid, 'estimateMoney')

					// 窗口移动事件
					window.onresize = () => {
						_barChart.resize()
					}
				}
			} else {
				// 概算价 图表
				let _estimate = this.$echarts.init(
					document.getElementById('estimate_chart')
				)
				this.initCharts(_estimate, 'pie', pid, 'estimateMoney')

				// 控制价 图表
				let _control = this.$echarts.init(
					document.getElementById('control_chart')
				)
				this.initCharts(_control, 'pie', pid, 'controlMoney')

				// 中标价 图表
				let _bidding = this.$echarts.init(
					document.getElementById('bidding_chart')
				)
				this.initCharts(_bidding, 'pie', pid, 'biddingMoney')

				// 报审价 图表
				let _report = this.$echarts.init(
					document.getElementById('report_chart')
				)
				this.initCharts(_report, 'pie', pid, 'reportMoney')

				// 初审价 图表
				let _before = this.$echarts.init(
					document.getElementById('before_chart')
				)
				this.initCharts(_before, 'pie', pid, 'beforeMoney')

				// 审定价 图表
				let _after = this.$echarts.init(
					document.getElementById('after_chart')
				)
				this.initCharts(_after, 'pie', pid, 'afterMoney')

				// 窗口移动事件
				window.onresize = () => {
					_estimate.resize() // 概算价
					_control.resize() // 控制价
					_bidding.resize() // 中标价
					_report.resize() // 报审价
					_before.resize() // 初审价
					_after.resize() // 审定价
				}

				setTimeout(() => {
					_estimate.resize() // 概算价
					_control.resize() // 控制价
					_bidding.resize() // 中标价
					_report.resize() // 报审价
					_before.resize() // 初审价
					_after.resize() // 审定价
				}, 300)
			}
		},
		// 切换展示 左侧树结构
		handleShow() {
			this.showLeft = !this.showLeft
			this.resizeChart()
		},
		// 左侧树宽度变化时，图表自适应
		resizeChart() {
			if (this.showType === 'bar') {
				let _barChart = this.$echarts.init(
					document.getElementById('bar_chart')
				)

				setTimeout(() => {
					_barChart.resize()
				}, 300)
			} else {
				let _estimate = this.$echarts.init(
					document.getElementById('estimate_chart')
				)

				// 控制价 图表
				let _control = this.$echarts.init(
					document.getElementById('control_chart')
				)

				// 中标价 图表
				let _bidding = this.$echarts.init(
					document.getElementById('bidding_chart')
				)

				// 报审价 图表
				let _report = this.$echarts.init(
					document.getElementById('report_chart')
				)

				// 初审价 图表
				let _before = this.$echarts.init(
					document.getElementById('before_chart')
				)

				// 审定价 图表
				let _after = this.$echarts.init(
					document.getElementById('after_chart')
				)

				// 大图
				let _biger
				if (this.showBigger) {
					_biger = this.$echarts.init(
						document.getElementById('enlarge_chart')
					)
				}

				setTimeout(() => {
					_estimate.resize() // 概算价
					_control.resize() // 控制价
					_bidding.resize() // 中标价
					_report.resize() // 报审价
					_before.resize() // 初审价
					_after.resize() // 审定价
					if (this.showBigger) {
						_biger.resize() // 大图
					}
				}, 300)
			}
		},
		// 切换展示 总概算 或者 概算价
		showTotalOrEstimate(type) {
			let _chart = this.$echarts.init(
				document.getElementById('estimate_chart')
			)
			if (type === 'total') {
				_chart.clear()
				this.initTotalChart(_chart, 'pie')
			} else {
				_chart.clear()
				this.initCharts(_chart, 'pie', this.curRowId, 'estimateMoney')
			}
		},
		// 切换展示 大图展示
		changeEnlarge(attr) {
			this.showBigger = true

			setTimeout(() => {
				let _item = document.getElementById('enlarge_chart')
				if (_item) {
					let _enlargeChart = this.$echarts.init(_item)
					_enlargeChart.clear()

					attr !== 'totalEstimate' ?
						this.initBigChart(_enlargeChart, this.curRowId, attr) :
						this.initBigTotal(_enlargeChart)

					// 窗口移动事件
					window.onresize = () => {
						_enlargeChart.resize()
					}
				}
			}, 300)
		},
		// 渲染大图
		initBigChart(echart, pid, attr) {
			let resData = []
			let that = this
			let titleObj = {
				totalEstimate: '总概算',
				estimateMoney: '概算价',
				controlMoney: `控制价`,
				biddingMoney: `中标价`,
				reportMoney: `报审价`,
				beforeMoney: `初审价`,
				afterMoney: `审定价`
				// controlMoney: `控制价（含预留金：${this.reservedObj.controlReserveMoney} ${this.curUnit}）`,
				// biddingMoney: `中标价（含预留金：${this.reservedObj.biddingReserveMoney} ${this.curUnit}）`,
				// reportMoney: `报审价（含预留金：${this.reservedObj.reportReserveMoney} ${this.curUnit}）`,
				// beforeMoney: `初审价（含预留金：${this.reservedObj.beforeReserveMoney} ${this.curUnit}）`,
				// afterMoney: `审定价（含预留金：${this.reservedObj.afterReserveMoney} ${this.curUnit}）`
			}

			// 获得对应的数据
			resData = this.listData.filter(x => x.pid === pid)
			let params = this.listData.find(x => x.id === pid)
			if (params) {
				if (this.curUnit === '元') {
					this.reservedObj.controlReserveMoney = params.controlReserveMoney || '0.00'
					this.reservedObj.biddingReserveMoney = params.biddingReserveMoney || '0.00'
					this.reservedObj.reportReserveMoney = params.reportReserveMoney || '0.00'
					this.reservedObj.beforeReserveMoney = params.beforeReserveMoney || '0.00'
					this.reservedObj.afterReserveMoney = params.afterReserveMoney || '0.00'
				} else {
					this.reservedObj.controlReserveMoney = (parseFloat(params.controlReserveMoney) / 10000).toFixed(2) || '0.00'
					this.reservedObj.biddingReserveMoney = (parseFloat(params.biddingReserveMoney) / 10000).toFixed(2) || '0.00'
					this.reservedObj.reportReserveMoney = (parseFloat(params.reportReserveMoney) / 10000).toFixed(2) || '0.00'
					this.reservedObj.beforeReserveMoney = (parseFloat(params.beforeReserveMoney) / 10000).toFixed(2) || '0.00'
					this.reservedObj.afterReserveMoney = (parseFloat(params.afterReserveMoney) / 10000).toFixed(2) || '0.00'
				}
			}

			// 定义数组
			let dataSource = []

			// 数据
			resData.forEach((y, index) => {
				let arrSource = []
				arrSource.push(y.sname)

				if (this.curUnit === '元') {
					arrSource.push(y.estimateMoney || 0)
					arrSource.push(y.controlMoney || 0)
					arrSource.push(y.biddingMoney || 0)
					arrSource.push(y.reportMoney || 0)
					arrSource.push(y.beforeMoney || 0)
					arrSource.push(y.afterMoney || 0)
				} else {
					arrSource.push((y.estimateMoney / 10000).toFixed(2) || 0)
					arrSource.push((y.controlMoney / 10000).toFixed(2) || 0)
					arrSource.push((y.biddingMoney / 10000).toFixed(2) || 0)
					arrSource.push((y.reportMoney / 10000).toFixed(2) || 0)
					arrSource.push((y.beforeMoney / 10000).toFixed(2) || 0)
					arrSource.push((y.afterMoney / 10000).toFixed(2) || 0)
				}
				dataSource.push(arrSource)
			})
			let colorList_old = [
				'#399be1',
				'#36cbcb',
				'#4ecb73',
				'#fbd437',
				'#da6fad',
				'#88b4ca',
				'#d18061',
				'#65c5bd',
				'#4fcce7',
				'#d16361',
				'#b38661',
			]

			let colorList = [
				"#B47C4B",
				"#7A64E7",
				"#5AF243",
				"#D00C87",
				"#D412CA",
				"#D367F7",
				"#65A554",
				"#D39C04",
				"#C64194",
				"#0C5BB6",
				"#7E0BB5",
				"#BD7DC9",
				"#0D3F7D",
				"#E1C6D8",
				"#85BD82",
				"#41B4E6",
				"#9ED366",
				"#435A37",
				"#072897",
				"#8CE78D",
				"#5967B1",
				"#4F61B9",
				"#853855",
				"#69677D",
				"#8768d3",
				"#A5901C",
				"#986D49",
				"#16E03E",
				"#DB3398",
				"#9CB426"
			]


			let activeOption = {
				legend: {
					type: 'scroll',
					top: '8%',
					left: 20,
					orient: 'vertical'
				},
				title: {
					text: this.curShowName,
					subtext: titleObj[attr],
					subtextStyle: {
						color: '#666',
						fontSize: 13
					},
					textAlign: 'center',
					top: '5px',
					left: '50%'
				},
				tooltip: {
					formatter: function(params) {
						let value = params.value[params.encode.value[0]]
						return `${params.name}: ${value} ${that.curUnit} </br>占比： ${params.percent} %`
					}
				},
				toolbox: {
					feature: {
						saveAsImage: {
							title: '保存为png',
							pixelRatio: 2
						}
					},
					top: 20
				},
				// 配置图层
				graphic: {
					type: 'text',
					left: 10, // 相对父元素居中
					bottom: '5%', // 相对父元素居中
					// invisible: this.isVisible ? false : true,
					style: {
						fill: '#333',
						text: [`导出人：${this.userName}`, '导出时间：' + dateFormatCN()].join(
							'\n'
						),
						font: '14px Microsoft YaHei'
					}
				},
				dataset: {
					source: [
						[
							'sname',
							'estimateMoney',
							'controlMoney',
							'biddingMoney',
							'reportMoney',
							'beforeMoney',
							'afterMoney',
							'total'
						],
						...dataSource
					]
				},
				series: [{
					type: 'pie',
					radius: 150,
					encode: {
						itemName: 'sname',
						value: attr
					},
					label: {
						normal: {
							formatter: `{b|{b}}\n{hr|}\n{value|{@${attr}} ${this.curUnit}}`,
							// formatter: `{b}{@${attr}} 元`,
							rich: {
								b: {
									lineHeight: 20
								},
								hr: {
									borderColor: '#5f9ea0',
									width: '100%',
									borderWidth: 0.5,
									height: 0,
									marginTop: 3
								},
								value: {
									lineHeight: 20
								}
							}
						}
					},
					itemStyle: {
						normal: {
							// 饼图块
							color: function(params) {
								let _index = params.dataIndex % that.allColorList.length
								return that.allColorList[_index]
								// return '#' + Math.random().toString(16).substr(2, 6).toUpperCase()
							}
						}
					}
				}]
			}

			echart.setOption(activeOption)

			// this.showBigger = true
		},

		// 渲染 总概算大图
		initBigTotal(echart) {
			let resData = this.totalEstimateData
			let that = this

			let colorList_old = [
				'#399be1',
				'#36cbcb',
				'#4ecb73',
				'#fbd437',
				'#da6fad',
				'#88b4ca',
				'#d18061',
				'#65c5bd',
				'#4fcce7',
				'#d16361',
				'#b38661'
			]

			let colorList = [
				"#B47C4B",
				"#7A64E7",
				"#5AF243",
				"#D00C87",
				"#D412CA",
				"#D367F7",
				"#65A554",
				"#D39C04",
				"#C64194",
				"#0C5BB6",
				"#7E0BB5",
				"#BD7DC9",
				"#0D3F7D",
				"#E1C6D8",
				"#85BD82",
				"#41B4E6",
				"#9ED366",
				"#435A37",
				"#072897",
				"#8CE78D",
				"#5967B1",
				"#4F61B9",
				"#853855",
				"#69677D",
				"#8768d3",
				"#A5901C",
				"#986D49",
				"#16E03E",
				"#DB3398",
				"#9CB426"
			]

			let activeOption = {
				legend: {
					type: 'scroll',
					top: '8%',
					left: 20,
					orient: 'vertical'
				},
				title: {
					text: this.curShowName,
					subtext: '总概算',
					subtextStyle: {
						color: '#666',
						fontSize: 13
					},
					textAlign: 'center',
					top: '5px',
					left: '50%'
				},
				tooltip: {
					formatter: function(params) {
						return `${params.name}: ${params.value} 元 </br>占比： ${params.percent} %`
					}
				},
				toolbox: {
					feature: {
						saveAsImage: {
							title: '保存为png',
							pixelRatio: 2
						}
					},
					top: 20
				},
				// 配置图层
				graphic: {
					type: 'text',
					left: 10, // 相对父元素居中
					bottom: '5%', // 相对父元素居中
					// invisible: this.isVisible ? false : true,
					style: {
						fill: '#333',
						text: ['导出人：xx', '导出时间：' + dateFormatCN()].join(
							'\n'
						),
						font: '14px Microsoft YaHei'
					}
				},
				series: [{
					type: 'pie',
					radius: 150,
					label: {
						normal: {
							formatter: `{b|{b}}\n{hr|}\n{value|{c}}元`,
							// formatter: `{b}{@${attr}} 元`,
							rich: {
								b: {
									lineHeight: 20
								},
								hr: {
									borderColor: '#5f9ea0',
									width: '100%',
									borderWidth: 0.5,
									height: 0,
									marginTop: 3
								},
								value: {
									lineHeight: 20
								}
							}
						}
					},
					itemStyle: {
						normal: {
							// 饼图块
							color: function(params) {
								return that.allColorList[params.dataIndex]
							}
						}
					},
					data: resData
				}]
			}

			echart.setOption(activeOption)
		},

		// 导出图片
		doExportPic() {
			let _barChart = this.$echarts.init(
				document.getElementById('bar_chart')
			)
			_barChart.setOption({
				title: {
					text: this.curShowName
				}
			})

			let anchor = document.createElement('a')
			// a 标签属性
			anchor.download = this.curShowName + '.png'
			anchor.href = _barChart.getDataURL({
				type: 'png',
				pixelRatio: 2,
				backgroundColor: '#fff',
				excludeComponents: ['toolbox']
			})
			anchor.click()

			setTimeout(() => {
				_barChart.setOption({
					title: {
						text: this.curName + '价格构成'
					}
				})
			}, 300)
		},

		// 展示标签
		toArray(str) {
			let arr = str.split(',').filter((x) => x !== '')
			return arr
		},
	},
	created() {
		// 初始获取数据
		this.getData()
		this.getChartsData()
		this.getTotalData()
		this.changeShow('pie')
		// 设置表格高度
		this.$nextTick(() => {
			this.tableH = this.$refs.tableContent.offsetHeight
		})

		// 设置颜色数组
		let list = []
		for (let i = 0; i < 50; i++) {
			let color = '#' + Math.random().toString(16).substr(2, 6).toUpperCase()
			list.push(color)
		}
		this.allColorList = list
	},
	mounted() {
		this.$nextTick(() => {})
	},
	computed: {
		curProjectId() {
			return this.$route.query.projectId
		},

		// 当前导出人
		userName() {
			return this.$route.query.userName
		},

		// 转化之后的 json 数据
		listData() {
			return this.$utils.toTreeArray(this.originalData)
		}
	},
	watch: {
		// 监听处理同一个菜单变化时，数据不变
		curProjectId(val) {
			this.getData()
			this.getChartsData()
			this.getTotalData()
		},

		// 单位变化
		curUnit(val) {
			if (val === '元') {
				// this.
			}
			setTimeout(() => {
				this.getCharts('pie', this.curRowId)
				this.showTotalOrEstimate()
				// this.changeEnlarge()
			}, 300)
		}
	}
}
</script>
<style lang="less" scoped>
@import url('./home.less');
</style>